<div
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 32px;
  "
>
  <div class="form-search">
    <mat-form-field class="search-field">
      <mat-label>Buscar clientes</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Digite para buscar..."
      />
      @if (loadingService.input$ | async) {
        <mat-icon matSuffix>
          <mat-spinner diameter="22"></mat-spinner>
        </mat-icon>
      } @else {
        <ng-container matSuffix>
          @if (searchControl.value) {
            <button
              mat-icon-button
              (click)="clearText()"
              [attr.aria-label]="'Limpar texto'"
            >
              <mat-icon>close</mat-icon>
            </button>
          } @else {
            <mat-icon>search</mat-icon>
          }
        </ng-container>
      }
    </mat-form-field>
  </div>

  <button
    matButton="filled"
    style="height: 56px"
    mat-flat-button
    (click)="navigateToNewOrganization()"
  >
    <mat-icon style="margin-right: 8px">add</mat-icon>
    Cadastrar Cliente
  </button>
</div>
<mat-card appearance="outlined">
  @if (loadingService.isLoad$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <table
    mat-table
    matSort
    (matSortChange)="search()"
    style="width: 100%"
    [dataSource]="dataSource"
    class="mat-elevation-z8"
    #table
  >
    <ng-container matColumnDef="cnpj">
      <th *matHeaderCellDef mat-sort-header>CNPJ</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ formatCNPJ(element.cnpj) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-sort-header>Nome da Empresa</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdDate">
      <th *matHeaderCellDef mat-sort-header>Data de Criação</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.createdDate | date: "dd/MM/yyyy" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef>Ações</th>
      <td mat-cell *matCellDef="let element; table: table">
        <div style="display: flex; gap: 8px">
          <button
            mat-icon-button
            color="primary"
            (click)="navigateToOrganizationDetails(element.id!)"
          >
            <mat-icon>visibility</mat-icon>
          </button>
          <button
            mat-icon-button
            color="accent"
            (click)="navigateToCreateContract(element.id!)"
            matTooltip="Cadastrar Contrato"
          >
            <mat-icon>note_add</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="activeContractsCount">
      <th *matHeaderCellDef mat-sort-header>Contratos Ativos</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.activeContractsCount }}
      </td>
    </ng-container>
    <ng-container matColumnDef="inactiveContractsCount">
      <th mat-sort-header *matHeaderCellDef>Contratos Inativos</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.inactiveContractsCount }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageIndex]="pageIndex"
    (page)="search($event.pageIndex)"
    style="background-color: transparent"
    showFirstLastButtons
  ></mat-paginator>
</mat-card>
